export const getAcronym = (str = '', separator = ' ', union = '') => {
  const words = str.split(separator).filter((word) => word);
  const letters = words.map((word) => word[0]);
  return letters.join(union);
};
